import { render, staticRenderFns } from "./storeFeedbackList.vue?vue&type=template&id=57f2e20b&scoped=true"
import script from "./storeFeedbackList.vue?vue&type=script&lang=js"
export * from "./storeFeedbackList.vue?vue&type=script&lang=js"
import style0 from "./storeFeedbackList.vue?vue&type=style&index=0&id=57f2e20b&scoped=true&lang=scss"
import style1 from "./storeFeedbackList.vue?vue&type=style&index=1&id=57f2e20b&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f2e20b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57f2e20b')) {
      api.createRecord('57f2e20b', component.options)
    } else {
      api.reload('57f2e20b', component.options)
    }
    module.hot.accept("./storeFeedbackList.vue?vue&type=template&id=57f2e20b&scoped=true", function () {
      api.rerender('57f2e20b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/storeFeedback/storeFeedbackList.vue"
export default component.exports